// Import: Middleware Action & Custom Types
import {
  CLEAN_CONSULTINGCHECKZIPCODE,
  CLEAN_CONSULTINGCHECKZIPCODE_ERROR,
} from '_models/redux/types';

// Action function
export const cleanConsultingCheckZipcodeAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_CONSULTINGCHECKZIPCODE,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_CONSULTINGCHECKZIPCODE_ERROR,
      payload: undefined,
    });
  }
};
